import React from 'react';
import MyNavbar from "../../../components/student/mynavbar/MyNavbar";
import ContactSection from "./ContactSection";
import ContactUs from './ContactUs';
// import VideoSection from './VideoSection';
import NGOSection from '../home/NGOSection';
import Footer from '../../../components/student/footer/Footer';


const Contact= () => {
    return(

      <div>
        <MyNavbar/>
        <ContactUs/>
        {/* <VideoSection/> */}
         <ContactSection/>
            <NGOSection/>
      
           <Footer/>
      </div>

 );
}

export default Contact;